import Lenis from 'lenis';

let instance = null;

export function initLenis() {
    instance = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    function raf(time) {
        instance.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
}

export function getLenis() {
    return instance;
}
